'use client';

export const SearchResultPageEffects = () => null;
